export const ErrorMessages = {
  'MSG-124':
    'Es necesario registrar la información de ventas históricas antes de realizar la consulta del dashboard.',
  'MSG-125':
    'Es necesario registrar la información de desafío de ventas del año de vigencia del proceso antes de realizar la consulta del dashboard',
  'MSG-128':
    'Es necesario registrar la información correspondiente a los acuerdos comerciales del año de vigencia del proceso antes de realizar la consulta del dashboard',
};
